<section class="container">
  @if (significantEvents.length > 0) {
    <table class="table">
      <thead>
        <tr>
          <th style="width: 45%">
            {{ labelService.getLabel("title") }}
          </th>
          <th style="width: 20%">
            {{ labelService.getLabel("start_date") }}
          </th>
          <th style="width: 20%">
            {{ labelService.getLabel("end_date") }}
          </th>
          <th style="width: 5%"></th>
          <th style="width: 5%"></th>
          <th style="width: 5%"></th>
        </tr>
      </thead>
      <tbody>
        @for (event of significantEvents; track event) {
          <tr>
            <td>{{ event.title }}</td>
            <td>{{ event.start_date }}</td>
            <td>{{ event.end_date }}</td>
            <td>
              @if (event.has_end_date) {
                <span
                  [class.clickable]="event.has_end_date"
                  (click)="event.has_end_date && toggleEventExpansion(event.id)"
                  class="material-icons"
                  style="font-size: 25px"
                >
                  expand
                </span>
              }
            </td>
            <td>
              @if (event.has_end_date) {
                <span
                  class="material-icons"
                  style="font-size: 25px; cursor: pointer"
                  (click)="addSubEvent(event)"
                >
                  add
                </span>
              }
            </td>
            <td style="cursor: pointer">
              <span
                class="material-icons"
                style="font-size: 25px"
                (click)="editOrDeleteEvent(event)"
              >
                {{ !hasModifyButtonBeenClicked ? "edit" : "delete" }}
              </span>
            </td>
          </tr>
          @if (expandedEvents[event.id]) {
            <tr class="sub-events">
              <td colspan="6">
                <table class="table">
                  @for (subEvent of event.sub_events; track subEvent) {
                    <tr>
                      <td style="width: 70%">{{ subEvent.title }}</td>
                      <td style="width: 20%">{{ subEvent.start_date }}</td>
                      <td style="width: 10%; cursor: pointer">
                        <span
                          class="material-icons"
                          style="font-size: 25px"
                          (click)="editOrDeleteSubEvent(subEvent)"
                        >
                          {{ !hasModifyButtonBeenClicked ? "edit" : "delete" }}
                        </span>
                      </td>
                      <td colspan="2"></td>
                    </tr>
                  }
                </table>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  }

  @if (significantEvents.length === 0) {
    <div class="no-events">
      <img
        src="assets/imgs/undraw/undraw_waiting_for_you.svg"
        alt="Nessun Evento"
      />
      <span>Nessun Evento Significativo</span>
    </div>
  }
</section>

@if (showEditPanel) {
  <app-panel-lifeline-event
    [panelTitle]="panelTitle"
    [eventTitle]="eventTitle"
    [eventStartDay]="eventStartDay"
    [eventStartMonth]="eventStartMonth"
    [eventStartYear]="eventStartYear"
    [eventEndDay]="eventEndDay"
    [eventEndMonth]="eventEndMonth"
    [eventEndYear]="eventEndYear"
    (cancel)="toggleEditEventPanel()"
    (confirm)="editSignificantEvent($event)"
  ></app-panel-lifeline-event>
}
